import { Formik } from "formik";
import React, { Component } from "react";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import Swal from "sweetalert2";
import InputCustom from "../../components/InputCustom";
import Button from "../../components/Button";
import * as equipe from "../../crud/equipe.crud";
import { validarFormulario } from "./EquipeUtils";
import styles from "../../styles/Equipe.module.scss";
import Breadcrumb from "../../components/Breadcrumb";
import CheckboxCustom from "../../components/CheckboxCustom";

export default class EquipeEdit extends Component {
    state = {
        loading: false,
        loading_inicial: true,
        valores_iniciais: null,
    };

    componentDidMount() {
        const { id } = this.props.match.params;

        equipe.get(id)
            .then((res) => {
                const colaborador = res.data;

                this.setState({
                    loading_inicial: false,
                    valores_iniciais: {
                        email: colaborador.email,
                        usr_nome: colaborador.usr_nome,
                        usr_pode_solicitar_viagens: colaborador.usr_pode_solicitar_viagens ?? false,
                        usr_possui_acesso_painel: colaborador.usr_possui_acesso_painel ?? false,
                    },
                });
            })
            .catch(() => {
                Swal.fire("Ops!", "Não foi possível carregar os dados do membro.", "error");
                this.props.history.push("/equipe");
            });
    }

    handleSalvar = (values, setErrors) => {
        const erros = validarFormulario(values);

        if (Object.keys(erros).length > 0) {
            setErrors(erros);

            const primeira_mensagem = Object.values(erros)[0];

            Swal.fire("Ops!", primeira_mensagem, "warning");

            return;
        }

        this.setState({ loading: true });

        const { id } = this.props.match.params;

        equipe.update({
            usr_nome: values.usr_nome,
            usr_pode_solicitar_viagens: values.usr_pode_solicitar_viagens,
            usr_possui_acesso_painel: values.usr_possui_acesso_painel,
        }, id)
            .then(() => {
                this.props.history.push("/equipe");
            })
            .catch(() => {
                Swal.fire("Ops!", "Erro ao salvar. Tente novamente.", "error");
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    render() {
        const { loading, loading_inicial, valores_iniciais } = this.state;

        if (loading_inicial) {
            return (
                <BetterCircularProgress loading={true} />
            );
        }

        return (
            <div className={styles.container}>
                <Breadcrumb paiTo="/equipe" paiLabel="Equipe" atual="Editar membro" />

                <Formik
                    initialValues={valores_iniciais}
                    enableReinitialize
                    onSubmit={() => {}}
                >
                    {({ values, setFieldValue, setErrors, handleBlur, touched, errors }) => (
                        <>
                            <div className={styles.card}>
                                <div>
                                    <p className={styles.secaoTitulo}>Dados gerais</p>

                                    <div className={styles.gridDuasColunas}>
                                        <InputCustom
                                            label="E-mail"
                                            name="email"
                                            type="email"
                                            value={values.email}
                                            disabled
                                        />

                                        <InputCustom
                                            label="Nome"
                                            name="usr_nome"
                                            type="text"
                                            value={values.usr_nome}
                                            onChange={(e) => setFieldValue("usr_nome", e.target.value)}
                                            onBlur={handleBlur}
                                            disabled={loading}
                                            required
                                            errors={errors}
                                            touched={touched}
                                        />
                                    </div>
                                </div>

                                <span className={styles.divisor} />

                                <div>
                                    <p className={styles.secaoTitulo}>Permissões</p>
                                    <p className={styles.secaoDescricao}>Defina o nível de permissões que o membro deve possuir.</p>

                                    <div className={styles.permissoesGrid}>
                                        <CheckboxCustom
                                            label="Permitir solicitação de viagens em nome da empresa"
                                            checked={values.usr_pode_solicitar_viagens}
                                            onChange={(e) => setFieldValue("usr_pode_solicitar_viagens", e.target.checked)}
                                            disabled={loading}
                                        />

                                        <CheckboxCustom
                                            label="Permitir acesso ao painel da empresa"
                                            checked={values.usr_possui_acesso_painel}
                                            onChange={(e) => setFieldValue("usr_possui_acesso_painel", e.target.checked)}
                                            disabled={loading}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={styles.botoesRodape}>
                                <Button
                                    type="button"
                                    variant="default"
                                    outlined
                                    size="md"
                                    disabled={loading}
                                    onClick={() => this.props.history.push("/equipe")}
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type="button"
                                    variant="primary"
                                    size="md"
                                    loading={loading}
                                    disabled={loading}
                                    onClick={() => this.handleSalvar(values, setErrors)}
                                >
                                    Salvar alterações
                                </Button>
                            </div>
                        </>
                    )}
                </Formik>
            </div>
        );
    }
}
